import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

/** Fetch active tahun_ajaran. Returns { active, loading, refresh }. */
export function useActiveTA() {
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/tahun-ajaran/active");
      setActive(data || null);
    } catch (_e) {
      setActive(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { active, loading, refresh };
}

export const TINGKATAN_LIST = [
  "Pra Al-Miftah",
  "Al-Miftah",
  "Kelas 1 Reguler",
  "Kelas 3 Reguler",
  "Takhossus 1",
  "Takhossus 2",
];

export function predikatOf(n) {
  if (n == null || isNaN(n)) return "-";
  const v = Math.round(Number(n));
  if (v >= 90) return "Mumtaz";
  if (v >= 80) return "Jayyid Jiddan";
  if (v >= 70) return "Jayyid";
  if (v >= 60) return "Maqbul";
  return "Dho'if";
}

export function predikatColor(predikat) {
  switch (predikat) {
    case "Mumtaz": return "bg-emerald-100 text-emerald-800";
    case "Jayyid Jiddan": return "bg-sky-100 text-sky-800";
    case "Jayyid": return "bg-violet-100 text-violet-800";
    case "Maqbul": return "bg-amber-100 text-amber-800";
    case "Dho'if": return "bg-red-100 text-red-800";
    default: return "bg-slate-100 text-slate-700";
  }
}
